import { useState } from "react";

import { Callout, Icon } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { CreateWorkspaceDialog } from "@/components/pages_logged_in/workspace/nav/SideNav/CreateWorkspace";

interface SwitchToWorkspaceProps {
  workspace: {
    id: string;
    name: string;
    urlSlug?: string;
  };
  path?: string;
}

export function SwitchToWorkspace({ workspace, path }: SwitchToWorkspaceProps) {
  const [createWorkspaceVisible, setCreateWorkspaceVisible] = useState(false);

  const redirectToWorkspace = (urlSlug?: string) => {
    window.location.href = `/to-workspace/${urlSlug || "personal-mode"}${path}`;
  };

  return (
    <>
      <Callout intent="warning" icon={null}>
        This service is only available to workspace
        <Box fontWeight={600} mt={2}>
          {workspace ? (
            <a
              href="#"
              onClick={() => {
                redirectToWorkspace(workspace?.urlSlug);
              }}
            >
              Switch to {workspace?.name} workspace <Icon icon="arrow-right" />
            </a>
          ) : (
            <a
              href="#"
              onClick={() => {
                setCreateWorkspaceVisible(true);
              }}
            >
              Create a workspace <Icon icon="arrow-right" />
            </a>
          )}
        </Box>
      </Callout>
      <CreateWorkspaceDialog
        visible={createWorkspaceVisible}
        setVisible={setCreateWorkspaceVisible}
      />
    </>
  );
}
